// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"9ec2d260","585":"9ec2d260","1410":"9ec2d260","6494":"a3e920b5","7401":"e6b7240d","7451":"a3e920b5","9896":"d26a4b59"}[chunkId] + ".chunk.css";
};